import {DELETE_MAGAZINE_ERROR, DELETE_MAGAZINE_START, DELETE_MAGAZINE_SUCCESS} from "../../types";

export default function delete_magazine(state, action) {
    switch (action.type) {
        case DELETE_MAGAZINE_START:
            return {
                ...state,
                loading: true,
                error: null
            };
        case DELETE_MAGAZINE_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null
            };
        case DELETE_MAGAZINE_ERROR:
            return {
                ...state,
                loading: false,
                error: action.detail
            };
        default:
            return {...state};
    }
}
